import {
  capraIconFieldArray,
  capraIconFieldBoolean,
  capraIconFieldDate,
  capraIconFieldFixed,
  capraIconFieldGeo,
  capraIconFieldJson,
  capraIconFieldNumeric,
  capraIconFieldString,
  capraIconFieldTime,
  capraIconFieldUnknown,
} from '@mode/capra';

import { IconTypes } from '@mode/shared/contract-common';

export const COLUMN_ICON_MAP: IconTypes.ColumnIconMap = {
  boolean: capraIconFieldBoolean,
  json: capraIconFieldJson,
  numeric: capraIconFieldNumeric,
  string: capraIconFieldString,
  fixed: capraIconFieldFixed,
  date: capraIconFieldDate,
  time: capraIconFieldTime,
  geo: capraIconFieldGeo,
  array: capraIconFieldArray,
  unknown: capraIconFieldUnknown,
};

export const COLUMN_ICON_TYPE_MAP: IconTypes.ColumnIconTypeMap = {
  boolean: 'boolean',
  json: 'json',
  number: 'numeric',
  integer: 'numeric',
  int: 'numeric',
  bigint: 'numeric',
  'double precision': 'numeric',
  double: 'numeric',
  real: 'numeric',
  float: 'numeric',
  decimal: 'numeric',
  string: 'string',
  character: 'string',
  'character varying': 'string',
  varchar: 'string',
  varchar2: 'string',
  nvarchar2: 'string',
  text: 'string',
  fixed: 'fixed',
  datetime: 'date',
  date: 'date',
  'timestamp with time zone': 'date',
  timestamp: 'date',
  'timestamp without time zone': 'date',
  timestampltz: 'date',
  timestampntz: 'date',
  time: 'time',
  geography: 'geo',
  geometrycollection: 'geo',
  array: 'array',
};
